import { useEffect, useState } from 'react'

import { withUIContext } from 'context'

import { Image } from 'components/common'

const BackTop = (props) => {
    const [toTopActive, setToTopActive] = useState('');

    useEffect(() => {
        if (props.winWidth > 1200) {

            window.addEventListener('scroll', scroll)

            return () => {
                window.addEventListener('scroll', scroll)
            }
        }
    }, [toTopActive])

    const scroll = () => {
        if (window.scrollY > props.winHeight / 2) {
            setToTopActive('active')
        } else {
            setToTopActive('')
        }
    }

    return props.winWidth > 1200 ? (
        <Image
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className={`toTop cursorPointer ${toTopActive}`}
            src='/images/toTop.svg' />
    ) : null
}

export default withUIContext(BackTop, ['winWidth', 'winHeight'])